export default function Chip() {
  return {
    MuiChip: {
      // defaultProps: {
      //   deleteIcon: () => <MIcon icon="cancel" variant="secondary" size={20} />
      // },

      styleOverrides: {
        root: {
          UserSelect: 'none !important'
        },
        colorDefault: {
          // '& .MuiChip-avatarMedium, .MuiChip-avatarSmall': {
          //   color: theme.palette.text.secondary
          // }
        }
        // outlined: {
        //   fontSize: '.875rem',
        //   lineHeight: '1rem',
        //   borderColor: theme.palette.grey[500_32],
        //   '&.MuiChip-colorPrimary': {
        //     color: theme.palette.primary.darkest,
        //     backgroundColor: theme.palette.primary.lightest,
        //     borderColor: 'transparent'
        //   },
        //   '&.MuiChip-colorSecondary': {
        //     color: theme.palette.secondary.darkest,
        //     backgroundColor: theme.palette.secondary.lightest,
        //     borderColor: 'transparent'
        //   },
        //   '&.MuiChip-colorInfo': {
        //     color: theme.palette.info.darkest,
        //     backgroundColor: theme.palette.info.lightest,
        //     borderColor: 'transparent'
        //   },
        //   '&.MuiChip-colorSuccess': {
        //     color: theme.palette.success.darkest,
        //     backgroundColor: theme.palette.success.lightest,
        //     borderColor: 'transparent'
        //   },
        //   '&.MuiChip-colorWarning': {
        //     color: theme.palette.warning.darkest,
        //     backgroundColor: theme.palette.warning.lightest,
        //     borderColor: 'transparent'
        //   },
        //   '&.MuiChip-colorError': {
        //     color: theme.palette.error.darkest,
        //     backgroundColor: theme.palette.error.lightest,
        //     borderColor: 'transparent'
        //   }
        // },
        // avatarColorInfo: {
        //   color: theme.palette.info.contrastText,
        //   backgroundColor: theme.palette.info.dark
        // },
        // avatarColorSuccess: {
        //   color: theme.palette.success.contrastText,
        //   backgroundColor: theme.palette.success.dark
        // },
        // avatarColorWarning: {
        //   color: theme.palette.warning.contrastText,
        //   backgroundColor: theme.palette.warning.dark
        // },
        // avatarColorError: {
        //   color: theme.palette.error.contrastText,
        //   backgroundColor: theme.palette.error.dark
        // }
      }
    }
  };
}
